// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET/POST /config/formas_pagamento/lista
 *
 * Returns the full list of payment methods (rows from config_formas_pagamento),
 * with forma_pagamento_nome translated in-place by translateObjectProperty.
 *
 * Wire shape: dados is a flat list of FormaPagamentoRow.
 *
 * @see FormasPagamento_FormaPagamentoRow
 * @see Formas_pagamento_model::busca_formas_pagamento()
 */
import type { FormasPagamento_FormaPagamentoRow } from './FormasPagamento_FormaPagamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type FormasPagamento_ListaResponseDados = FormasPagamento_FormaPagamentoRow[];

export type FormasPagamento_ListaResponse = ApiResponse<FormasPagamento_ListaResponseDados>;

registerResponseContract('FormasPagamento_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      forma_pagamento_id:                   { type: 'number',  required: true },
      forma_pagamento_possui_taxas:         { type: 'number',  required: false },
      forma_pagamento_aceita_parcelado:     { type: 'number',  required: false },
      forma_pagamento_nome:                 { type: 'string',  required: true },
      forma_pagamento_taxa_mensal:          { type: 'number',  required: false },
      forma_pagamento_taxa_transacao:       { type: 'number',  required: false },
      forma_pagamento_taxa_transacao_tipo:  { type: 'number',  required: false },
      background_color:                     { type: 'string',  required: false },
      forma_pagamento_codigo:               { type: 'string',  required: false },
      forma_pagamento_parcelas_max:         { type: 'number',  required: false },
      forma_pagamento_parcelas_max_efetivo: { type: 'number',  required: false },
      forma_pagamento_dias_para_receber:    { type: 'number',  required: false },
    },
  },
})
